import { QuoteTaskGroupsService } from "@common/client"
import { makeAxiosMutation, makeQuery } from "../utils"

export const taskGroupsBaseKey = ["quote-task-groups"] as const

export const taskGroupsKey = (deleted: boolean) =>
  [...taskGroupsBaseKey, { deleted }] as const

export const taskGroupsQuery = makeQuery({
  serviceCall: ({ deleted }: { deleted: boolean }) =>
    QuoteTaskGroupsService.listQuoteTaskGroups({ deleted }),
  queryKey: ({ deleted }) => taskGroupsKey(deleted),
})

export const useCreateTaskGroupMutation = makeAxiosMutation({
  serviceCall: QuoteTaskGroupsService.create,
  invalidates: () => [taskGroupsKey(false)],
})

export const useImportTaskGroupsMutation = makeAxiosMutation({
  serviceCall: QuoteTaskGroupsService.createMany,
  invalidates: () => [taskGroupsBaseKey],
})

export const useUpdateTaskGroupMutation = makeAxiosMutation({
  serviceCall: QuoteTaskGroupsService.update,
  invalidates: () => [taskGroupsKey(false)],
})

export const useReorderTaskGroupsMutation = makeAxiosMutation({
  serviceCall: QuoteTaskGroupsService.reorder,
  invalidates: () => [taskGroupsKey(false)],
})

export const useDeleteTaskGroupMutation = makeAxiosMutation({
  serviceCall: QuoteTaskGroupsService.delete,
  invalidates: () => [taskGroupsBaseKey],
})

export const useRestoreTaskGroupMutation = makeAxiosMutation({
  serviceCall: QuoteTaskGroupsService.restore,
  invalidates: () => [taskGroupsBaseKey],
})
